import { Collapse } from "bootstrap";

var utbildning = (function () {
  function initKurspaketkurser() {
    var kurspaketkurser = document.getElementById("kurspaketkurslista");
    if (kurspaketkurser) {
      var kurspaketkurslistor = kurspaketkurser.querySelectorAll(".accordion");
      if (kurspaketkurslistor.length > 1) {
        var tillfallesflikar = document.getElementById(
          "utbildningstillfallefilkar"
        );
        if (tillfallesflikar) {
          var knappar = tillfallesflikar.getElementsByTagName("button");
          var statusTermin = document.getElementById(
            "kurspaketkurser-status-termin"
          );
          for (const knapp of knappar) {
            knapp.addEventListener("click", function (event) {
              var knapptext = event.target.textContent;
              var openCollapse = kurspaketkurser.querySelectorAll(
                ".accordion-collapse.collapse.show"
              );
              for (const collapseEl of openCollapse) {
                Collapse.getOrCreateInstance(collapseEl).hide();
              }

              if (knapptext) {
                for (const kurspaketkurslista of kurspaketkurslistor) {
                  var id = kurspaketkurslista.getAttribute("id");

                  if (id && id.includes(knapptext)) {
                    kurspaketkurslista.classList.remove("d-none");
                    kurspaketkurslista.classList.add("d-block");
                    var terminstext =
                      kurspaketkurslista.getAttribute("data-termintext");
                    if (statusTermin && terminstext) {
                      statusTermin.textContent = terminstext;
                    }
                  } else {
                    kurspaketkurslista.classList.remove("d-block");
                    kurspaketkurslista.classList.add("d-none");
                  }
                }
              }
            });
          }
        }
      }
    }
  }
  return {
    initKurspaketkurser: initKurspaketkurser,
  };
})();

export default utbildning;
